var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard" }, [
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _c("div", { staticClass: "row heading" }, [
          _c("div", { staticClass: "col-sm-6" }, [
            _c("h1", [_vm._v(_vm._s(_vm.title))])
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.getSections(), function(section) {
          return _c(
            section.component,
            { key: section.name, tag: "component" },
            _vm._l(_vm.getSectionParts(section.name), function(part) {
              return _c(
                part.component,
                _vm._b(
                  {
                    key: part.name,
                    tag: "component",
                    class: part.cssClass,
                    attrs: { slot: part.name },
                    slot: part.name
                  },
                  "component",
                  part.config,
                  false
                )
              )
            }),
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-abc804dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abc804dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/DashboardComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-abc804dc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/DashboardComponent.vue
// module chunks = 0